/**
 * Identidade de um SETOR (workspace).
 *
 * O id sai do nome, por slug. Ele nao e cosmetico: aparece na URL, e o valor
 * gravado em `devices.current_workspace_id` e em `dashboard_layout_settings`.
 * Por isso a regra vive aqui, uma vez — servidor e navegador precisam produzir
 * o MESMO id para o mesmo nome, e duas implementacoes que divergissem
 * criariam setores que a interface mostra e a API nao encontra.
 */

/** Limite do id. A coluna e TEXT, mas um id de URL nao deve crescer sem fim. */
export const WORKSPACE_ID_MAX = 64;

/**
 * "Subestações" -> "subestacoes". Acentos caem, o resto vira hifen.
 *
 * `existentes` resolve colisao com sufixo numerico: dois setores com o mesmo
 * nome sao legitimos ("Prensa" na fabrica A e na B), e falhar seria pior do
 * que numerar.
 */
export function idDeWorkspace(nome: string, existentes: readonly string[] = []): string {
  const base =
    nome
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, WORKSPACE_ID_MAX) || "setor";

  let candidato = base;
  let sufixo = 2;
  while (existentes.includes(candidato)) {
    candidato = `${base}-${sufixo}`;
    sufixo += 1;
  }
  return candidato;
}

/**
 * Um id que veio de FORA (migracao do `localStorage`) serve?
 *
 * A migracao precisa preservar ids antigos, mas nao pode virar porta para
 * qualquer texto: o valor entra em URL e em consulta. Aceita o que o proprio
 * `idDeWorkspace` produziria.
 */
export function ehIdDeWorkspaceValido(valor: unknown): valor is string {
  return (
    typeof valor === "string" &&
    valor.length > 0 &&
    valor.length <= WORKSPACE_ID_MAX &&
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(valor)
  );
}
